/* Innervis theme — cart drawer, quantity, variant picker, nav.
   Talks to Shopify's AJAX Cart API; the drawer markup is re-rendered through
   the Section Rendering API so Liquid stays the single source of truth. */

(function () {
  'use strict';

  var routes = (window.Innervis && window.Innervis.routes) || {};

  function money(cents) {
    var format = (window.Innervis && window.Innervis.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, amount)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  /* ---------------------------------------------------------------- drawer */
  function drawer() {
    return document.querySelector('[data-drawer]');
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    d.hidden = false;
    document.body.classList.add('drawer-open');
    var close = d.querySelector('.drawer__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.hidden = true;
    document.body.classList.remove('drawer-open');
  }

  function refreshDrawer(open) {
    return fetch('?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-drawer]');
        var current = drawer();
        if (fresh && current) {
          var wasOpen = !current.hidden;
          current.replaceWith(fresh);
          if (wasOpen || open) openDrawer();
        }
        return fetch(routes.cart).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = 'Cart ' + cart.item_count;
        });
        return cart;
      });
  }

  function addToCart(items, button) {
    if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Adding…'; }
    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        return refreshDrawer(true);
      })
      .catch(function (err) {
        var note = document.querySelector('[data-cart-error]');
        if (note) note.textContent = err.message;
        else alert(err.message);
      })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = button.dataset.label || 'Add to cart'; }
      });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { return refreshDrawer(false); });
  }

  /* ------------------------------------------------------------- listeners */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open-cart]');
    if (open) { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest('[data-close-cart]')) { closeDrawer(); return; }

    var add = e.target.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      addToCart([{ id: Number(add.dataset.addVariant), quantity: 1 }], add);
      return;
    }

    var routine = e.target.closest('[data-add-routine]');
    if (routine) {
      e.preventDefault();
      var ids = routine.dataset.addRoutine.split(',').filter(Boolean);
      addToCart(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), routine);
      return;
    }

    var line = e.target.closest('[data-line-change]');
    if (line) {
      e.preventDefault();
      changeLine(line.dataset.lineKey, Number(line.dataset.lineChange));
      return;
    }

    var step = e.target.closest('[data-qty]');
    if (step) {
      var input = step.parentElement.querySelector('[data-qty-input]');
      if (input) {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qty));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var burger = e.target.closest('[data-burger]');
    if (burger) {
      var nav = document.querySelector('[data-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* --------------------------------------------------------- product form */
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var variants = JSON.parse(document.querySelector('[data-variant-data]').textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price-display]');
    var perDayEl = document.querySelector('[data-perday]');
    var submit = form.querySelector('[data-submit-text]');
    var qtyInput = form.querySelector('[data-qty-input]');

    function current() {
      return variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || variants[0];
    }

    function render() {
      var v = current();
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (priceEl) priceEl.textContent = money(v.price);
      if (submit) submit.textContent = v.available ? money(v.price * qty) : 'Sold out';
      form.querySelector('[type="submit"]').disabled = !v.available;
      if (perDayEl && v.days) {
        var perDay = v.price / v.days;
        perDayEl.textContent = (perDay < 100 ? Math.round(perDay) + '¢' : money(perDay)) +
          ' a day · ' + v.days + '-day supply';
      }
    }

    form.querySelectorAll('[data-variant-option]').forEach(function (opt) {
      opt.addEventListener('change', function () { idInput.value = opt.value; render(); });
    });
    qtyInput.addEventListener('change', render);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(
        [{ id: Number(idInput.value), quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) }],
        form.querySelector('[type="submit"]')
      );
    });

    render();
  });
})();
